export default __webpack_public_path__ + "static/media/redux.1e40a3e5.svg";